<template>
  <b-row class="justify-content-xl-center">
    <b-col class="col-xl-10">

      <h3>Login</h3>

      <b-form id="loginForm" @submit.prevent="login">

        <b-form-group label-for="username" label="Email">
          <b-form-input type="text" id="username" v-model="username" autofocus autocomplete="username"/>
        </b-form-group>

        <b-form-group label-for="Password" label="Passwort">
          <b-form-input type="password" id="password" v-model="password" autocomplete="current-password"/>
          <router-link :to="{name: 'password', params: {email: username}}">Passwort vergessen?</router-link><br/>
          <router-link :to="{name: 'resend'}">Email nicht bestätigt?</router-link>
        </b-form-group>

        <b-form-group class="float-right">
          <b-button type="submit">Login</b-button>
        </b-form-group>

      </b-form>

    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      username: '',
      password: ''
    }
  },

  methods: {
    login: function () {
      this.$eventHub.$emit('login', this.username, this.password)
    }
  },

  mounted () {
    this.$parent.header = 'Login'

    // pre-fill email if submitted as GET param
    if (this.$route.query.email) {
      this.username = this.$route.query.email
    } else if (this.$route.params.email) {
      this.username = this.$route.params.email
    }

    if (this.$route.params.from === undefined) {
      return
    }

    switch (this.$route.params.from) {
      case 'logout':
        this.$eventHub.$emit('alertInfo', 'Sie haben sich erfolgreich abgemeldet')
        break
      case 'mounted':
        this.$eventHub.$emit('alertInfo', 'Ihre Anmeldung ist abgelaufen. Bitte loggen Sie sich erneut ein')
        break
      case 'request':
        this.$eventHub.$emit('logout')
        this.$eventHub.$emit('alertError', 'Sie sind nicht angemeldet oder Ihre Anmeldung ist abgelaufen.')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/views/guests/auth/Login.vue